var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup39(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "72px",
    viewBox: "0 0 82 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "818FD9C9-BCA9-4A4B-8833-EF71CCAF328F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.-AVAILABILITY-OF-HANA-UI",
    transform: "translate(-508.000000, -295.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(508.000000, 296.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-39",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,13.6466997 C0,10.5411057 2.53668354,8 5.63727601,8 L74.362724,8 C77.4631351,8 80,10.5411057 80,13.6466997 L80,64.3533003 C80,67.4590759 77.4631351,70 74.362724,70 L5.63727601,70 C2.53668354,70 0,67.4590759 0,64.3533003 L0,13.6466997 Z",
    id: "Stroke-1",
    stroke: "#222456",
    strokeWidth: 1.43955,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,16 C60.7915876,16 59,14.3071428 59,12.2208414 L59,3.77897481 C59,1.69267346 60.7915876,0 63,0 C65.2084124,0 67,1.69267346 67,3.77897481 L67,12.2208414 C67,14.3071428 65.2084124,16 63,16",
    id: "Fill-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,16 C60.7915876,16 59,14.3071428 59,12.2208414 L59,3.77897481 C59,1.69267346 60.7915876,0 63,0 C65.2084124,0 67,1.69267346 67,3.77897481 L67,12.2208414 C67,14.3071428 65.2084124,16 63,16 Z",
    id: "Stroke-5",
    stroke: "#ED7330",
    strokeWidth: 1.43955,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,16 C14.7915876,16 13,14.3071428 13,12.2208414 L13,3.77897481 C13,1.69267346 14.7915876,0 17,0 C19.2082178,0 21,1.69267346 21,3.77897481 L21,12.2208414 C21,14.3071428 19.2082178,16 17,16",
    id: "Fill-7",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,16 C14.7915876,16 13,14.3071428 13,12.2208414 L13,3.77897481 C13,1.69267346 14.7915876,0 17,0 C19.2082178,0 21,1.69267346 21,3.77897481 L21,12.2208414 C21,14.3071428 19.2082178,16 17,16 Z",
    id: "Stroke-9",
    stroke: "#ED7330",
    strokeWidth: 1.43955,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(0.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.154435082,
    y1: 0.128352,
    x2: 79.8383138,
    y2: 0.128352,
    id: "Fill-11",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.154435082,
    y1: 0.128352,
    x2: 79.8383138,
    y2: 0.128352,
    id: "Stroke-13",
    stroke: "#222456",
    strokeWidth: 1.43955,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56,47 C56,55.8365232 48.8365232,63 40,63 C31.1634768,63 24,55.8365232 24,47 C24,38.1634768 31.1634768,31 40,31 C48.8365232,31 56,38.1634768 56,47",
    id: "Fill-15",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,47 C56,55.8365232 48.8365232,63 40,63 C31.1634768,63 24,55.8365232 24,47 C24,38.1634768 31.1634768,31 40,31 C48.8365232,31 56,38.1634768 56,47 Z",
    id: "Stroke-17",
    stroke: "#222456",
    strokeWidth: 1.43955,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 41,
    x2: 46,
    y2: 52,
    id: "Stroke-19",
    stroke: "#222456",
    strokeWidth: 1.43955,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 41,
    x2: 35,
    y2: 52,
    id: "Stroke-21",
    stroke: "#222456",
    strokeWidth: 1.43955,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(62.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-23",
    fill: "#FFFFFF",
    points: "0.0550677273 8.60590882 0.0550677273 0.0332124545 8.62759227 0.0332124545"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-25",
    stroke: "#222456",
    strokeWidth: 1.43955,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "0.0550677273 8.60590882 0.0550677273 0.0332124545 8.62759227 0.0332124545"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(9.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-27",
    fill: "#FFFFFF",
    points: "0.113537455 8.60590882 0.113537455 0.0332124545 8.686062 0.0332124545"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-29",
    stroke: "#222456",
    strokeWidth: 1.43955,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "0.113537455 8.60590882 0.113537455 0.0332124545 8.686062 0.0332124545"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-34",
    transform: "translate(62.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-31",
    fill: "#FFFFFF",
    points: "0.0550677273 8.68752245 0.0550677273 0.114997909 8.62759227 0.114997909"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-33",
    stroke: "#222456",
    strokeWidth: 1.43955,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "0.0550677273 8.68752245 0.0550677273 0.114997909 8.62759227 0.114997909"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-38",
    transform: "translate(9.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-35",
    fill: "#FFFFFF",
    points: "0.113537455 8.68752245 0.113537455 0.114997909 8.686062 0.114997909"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-37",
    stroke: "#222456",
    strokeWidth: 1.43955,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "0.113537455 8.68752245 0.113537455 0.114997909 8.686062 0.114997909"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup39);
export default __webpack_public_path__ + "static/media/Group39.2787edb1.svg";
export { ForwardRef as ReactComponent };